export default __webpack_public_path__ + "static/media/faq.3b50def6.png";